import React, { useState } from 'react';
import { Alert, Button, CircularProgress } from '@mui/material';
import { extractErrorMessage } from '../../../utils/errorHandler';
import { ComptoirRevoir } from '../../../types/comptoir';

const fD = (d?: string | null) => (d ? new Date(d).toLocaleDateString('fr-FR') : '—');

/** V8 « Travaux modifiés »: the commercial changed the travaux of a launched job.
 *  Production side (with onVu): « Vérifiez les étapes et le plan » + « Vu ».
 *  Commercial side (no onVu): « pas encore vue par la production ». */
const TravauxModifiesAlert: React.FC<{ revoir?: ComptoirRevoir | null; onVu?: () => Promise<unknown>; sx?: object }> = ({ revoir, onVu, sx }) => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState('');
  if (!revoir) return null;
  if (!onVu) {
    return (
      <Alert severity="info" sx={sx}>
        Modification des travaux (version {revoir.version}) transmise à la production le {fD(revoir.le)} : pas encore vue par la production.
      </Alert>
    );
  }
  const vu = async () => {
    setBusy(true); setErr('');
    try { await onVu(); } catch (e: any) { setErr(extractErrorMessage(e)); } finally { setBusy(false); }
  };
  return (
    <Alert severity="warning" sx={sx}
      action={<Button color="inherit" size="small" onClick={vu} disabled={busy} startIcon={busy ? <CircularProgress size={14} /> : undefined}>Vu</Button>}>
      Le service commercial a modifié les travaux (version {revoir.version}, le {fD(revoir.le)}{revoir.par ? ` par ${revoir.par}` : ''}
      {revoir.motif ? ` : ${revoir.motif}` : ''}). Vérifiez les étapes et le plan.
      {err && <><br /><b>{err}</b></>}
    </Alert>
  );
};

export default TravauxModifiesAlert;
